import OtherSkills from "../../components/OtherSkills";
import { order } from "../SmartSearchParammeter";

export default async function OtherSkillsConfig(key) {
  return {
    description: "Other Skills",
    id: "otherSkills",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <OtherSkills searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["otherSkills"] = value[0];
    }
  };
}
